import { Injectable } from '@angular/core';
import { LocalStorageUtil } from '__utils';
import { environment } from '__env';
@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private key = 'userProfile';
  private lang_key = 'userLang';
  constructor(
  ) { }

  cache(profile: any) {
    LocalStorageUtil.set(this.key, JSON.stringify(profile));
    LocalStorageUtil.set(this.lang_key, profile.language);
  }

  get() {
    const profile = LocalStorageUtil.get(this.key);
    if (profile) {
      return JSON.parse(profile);
    }
    return null;
  }

  clear() {
    LocalStorageUtil.remove(this.key);
  }

  modules() {
    const profile = this.get();
    if (profile) {
      return profile.role?.modules || [];
    }
    return [];
  }

  features() {
    
  }

  language() {
    const lang = LocalStorageUtil.get(this.lang_key);
    if (lang) {
      const langSupport = environment.LANGUAGE.Support as string[];
      if (langSupport.includes(lang)) {
        return lang;
      }
    }
    return environment.LANGUAGE.Default;
  }

  company() {
    const profile = this.get();
    if (profile) {
      return profile.company;
    }
    return null;
  }

  companyIdentifier() {
    const company = this.company();
    if (company) {
      return company.identifier;
    }
    return null;
  }

  email() {
    const profile = this.get();
    if (profile) {
      return profile.contact_email;
    }
    return null;
  }

  settings() {
    const profile = this.get();
    if (profile) {
      return profile.settings
    }
    return null;
  }

  customBar() {
    const settings = this.settings();
    if (settings) {
      return settings.custom_bar;
    }
    return null
  }
}